<template>
  <div
    class="main-block"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="Wczytywanie..."
  >
    <div class="nav">
      <nav-header></nav-header>
    </div>
    <div class="tabs">
      <el-tabs v-model="active">
        <el-tab-pane label="Tabela krów" name="first">
          <cows-tab class="my-table" :cows="filteredCows" :groups="groups"></cows-tab>
        </el-tab-pane>
        <el-tab-pane label="Inseminacje" name="second">
          <inseminations-tab :herd-settings="herdSettings" :cows="filteredCows"></inseminations-tab>
        </el-tab-pane>
        <el-tab-pane label="Wycielenia" name="third">
          <calving-tab :herd-settings="herdSettings" :cows="filteredCows"></calving-tab>
        </el-tab-pane>
        <el-tab-pane label="Historia leczenia" name="fourth">
          <treatment-tab :cows="filteredCows" :drugs="drugs"></treatment-tab>
        </el-tab-pane>
        <el-tab-pane :label="cowsCounter" name="Liczba wyświetlanych krów" disabled></el-tab-pane>
        <el-tab-pane :label="statsDateLabel" name="Data aktualizacji statystyk" disabled></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <add-cow-modal :groups="groups"></add-cow-modal>
    </div>
  </div>
</template>

<script>
import bus from "@/bus";
import axios from "axios";
import lodash from "lodash";
import NavHeader from "@/components/NavHeader";
import CowsTab from "@/components/CowsTab";
import InseminationsTab from "@/components/InseminationsTab";
import CalvingTab from "@/components/CalvingTab";
import TreatmentTab from "@/components/TreatmentTab";
import AddCowModal from "@/components/AddCowModal";

import { serverAddress } from "../config";

const GET_COWS_SUCCESS_MESSAGE = "Pomyślnie pobrano krowy";
const SAVE_COW_SUCCESS_MESSAGE = "Pomyślnie zapisano krowę";
const SAVE_NEW_COW_SUCCESS_MESSAGE = "Pomyślnie dodano krowę";
const GET_SETTINGS_SUCESS_MESSAGE = "Pomyślnie poprano ustawnienia";
const DELETE_COW_SUCCESS_MESSAGE = "Pomyślnie usunięto krowę";

export default {
  data: function() {
    return {
      fullscreenLoading: false,
      active: "first",
      cows: [],
      groups: [],
      drugs: [],
      searchQuery: "",
      herdSettings: {},
      statsDate: ""
    };
  },
  computed: {
    filteredCows: function() {
      var filterKey = this.searchQuery && this.searchQuery.toLowerCase();
      var cows = this.cows;
      console.log("Oswiezam szukane: ", this.searchQuery);
      if (filterKey) {
        cows = cows.filter(function(row) {
          return (
            String(row.number)
              .toLowerCase()
              .indexOf(filterKey) > -1
          );
        });
      }
      return cows;
    },
    cowsCounter: function() {
      return "Liczba wyświetlanych krów: " + this.filteredCows.length;
    },
    statsDateLabel: function() {
      return "Data statystyk: " + this.statsDate;
    }
  },
  created: function() {
    bus.$on("successMessage", this.showSuccessMessage);
    bus.$on("errorMessage", this.showErrorMessage);
    bus.$on("loading-stop", this.stopLoading);
    bus.$on("loading-start", this.startLoading);
    bus.$on("save-cow", this.saveCow);
    bus.$on("save-new-cow", this.saveNewCow);
    bus.$on("delete-cow", this.deleteCow);
    bus.$on("search-query-send", this.setSearchQuery);
    bus.$on("print-page", this.print);
    bus.$on("apply-filters", this.applyFilters);

    bus.$on("getCows", this.getCows);
  },
  mounted: function() {
    this.getCows("/api/cattle");
    this.getSettings();
    this.getGroups();
    this.getDrugs();

    axios
      .get(serverAddress + "/api/stats/lastmonth", {
        auth: {
          username: "foo",
          password: "bar"
        }
      })
      .then(
        function(response) {
          console.log(response);
          this.statsDate = response.data;
        }.bind(this)
      )
      .catch(function(error) {
        console.log(error);
      });
  },
  methods: {
    showErrorMessage(message = "Błąd!") {
      this.$message({
        message: message,
        showClose: true,
        type: "error"
      });
    },
    showSuccessMessage: lodash.debounce(function(
      message = "Operacja zakończona sukcesem."
    ) {
      this.$message({
        message: message,
        showClose: true,
        type: "success"
      });
    },
    500),
    startLoading() {
      this.fullscreenLoading = true;
    },
    stopLoading() {
      this.fullscreenLoading = false;
    },
    getCows(url) {
      this.startLoading();

      axios
        .get(serverAddress + url, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.cows = response.data;
            console.log("Ilosc krow:", this.cows.length);
            this.stopLoading();
            this.showSuccessMessage(GET_COWS_SUCCESS_MESSAGE);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage(GET_COWS_SUCCESS_MESSAGE);
            this.stopLoading();

            console.log(error);
          }.bind(this)
        );
    },
    getGroups() {
      axios
        .get(serverAddress + "/api/groups", {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.groups = response.data;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            console.log(error);
          }.bind(this)
        );
    },
    getDrugs() {
      axios
        .get(serverAddress + "/api/drugs", {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.drugs = response.data;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            console.log(error);
          }.bind(this)
        );
    },
    getSettings() {
      axios
        .get(serverAddress + "/api/settings/herd", {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.herdSettings = response.data;
            this.showSuccessMessage(GET_SETTINGS_SUCESS_MESSAGE);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            console.log(error);
          }.bind(this)
        );
    },
    saveCow(cow) {
      console.log("Cow:", cow);

      let url = serverAddress + "/api/cattle/female/" + cow.number
      if( 'wichrz' in cow) {
        url = serverAddress + "/api/cattle/female/saveandsendinsemmination/" + cow.cow.number
      }
      axios
        .put(url, cow, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.showSuccessMessage(SAVE_COW_SUCCESS_MESSAGE);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            this.stopLoading();

            console.log(error);
          }.bind(this)
        );
    },
    saveNewCow(cow, calving = false) {
      console.log("dodaje krowe: calving", calving);
      console.log("dodaje krowe: cow", cow);
      axios
        .post(serverAddress + "/api/cattle/female", cow, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            console.log(response);
            this.cows.push(cow);

            bus.$emit("add-calving", cow.birth_date);
            this.showSuccessMessage(SAVE_NEW_COW_SUCCESS_MESSAGE);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            this.stopLoading();

            console.log(error);
          }.bind(this)
        );
    },
    deleteCow(cow) {
      axios
        .delete(serverAddress + "/api/cattle/female/" + cow.number, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.cows = this.cows.filter(
              function(item) {
                return cow.number != item.number;
              }.bind(this)
            );

            console.log(response);

            this.showSuccessMessage(DELETE_COW_SUCCESS_MESSAGE);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            this.stopLoading();

            console.log(error);
          }.bind(this)
        );
    },
    setSearchQuery(searchQuery) {
      this.searchQuery = searchQuery;
    },
    applyFilters(selectedFilters) {
      this.startLoading();

      console.log("Wybrane filtry:", selectedFilters);

      axios
        .post(serverAddress + "/api/filters", selectedFilters, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            console.log(response);
            this.cows = response.data;
            console.log("Ilosc krow:", this.cows.length);
            this.stopLoading();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.showErrorMessage();
            this.stopLoading();

            console.log(error);
          }.bind(this)
        );
    },
    print() {
      console.log("print");

      window.cows = this.filteredCows;
      var printWindow = window.open("/wydruk", "http://localhost:8080");

      // setTimeout(() => {
      //   printWindow.postMessage(
      //     { cows: this.filteredCows },
      //     "http://localhost:8080"
      //   );
      //   console.log("send");
      // }, 1000);
    }
  },
  components: {
    NavHeader,
    CowsTab,
    InseminationsTab,
    CalvingTab,
    TreatmentTab,
    AddCowModal
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
}

* {
  box-sizing: border-box;
}

.main-block {
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.my-table {
  height: calc(100vh - 118px) !important;
}

.el-table__body,
.el-table__header {
  table-layout: auto;
}

.my-btn {
  width: 100%;
}

.my-btn-panel {
  margin-left: 10px;
  margin-right: 10px;
}

.my-label {
  margin-bottom: 10px;
  margin-top: 10px;
  display: block;
}

.el-menu {
  border-radius: 0px;
}

/* ---- inseminations tab --*/

.send-insemination-block {
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.btn {
  margin-top: 10px;
  margin-bottom: 10px;
}

.wirzch-login-iframe {
  display: none;
}

.ertus-switch {
  margin-top: 10px;
}

.notransition {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}

.el-table--striped .el-table__body tr.current-row:nth-child(2n) td,
.el-table__body tr.current-row > td {
  background: #2598f5 !important;
}

.estrus-row-mark {
  background-color: #fda4a4 !important;
}
</style>
